import { invokeApi } from "@/utils/supabaseEdgeFunction";

export type RealtimeRevisionsResponse = {
  programAiRev?: number;
  eventRev?: number;
  redisConfigured?: boolean;
};

/**
 * Reads Redis-backed revision counters (`GET /api/realtime/revisions`).
 * When Redis is not configured, `redisConfigured` is false and callers should fall back
 * to polling the database directly.
 */
export async function fetchRealtimeRevisions(opts: {
  programId?: string;
  eventId?: string;
}): Promise<RealtimeRevisionsResponse> {
  const q = new URLSearchParams();
  if (opts.programId) q.set("programId", opts.programId);
  if (opts.eventId) q.set("eventId", opts.eventId);
  const suffix = q.toString() ? `?${q}` : "";
  const { data, error } = await invokeApi<RealtimeRevisionsResponse>(
    `realtime/revisions${suffix}`,
    { method: "GET", anonymous: true }
  );
  if (error || !data) {
    return { redisConfigured: false };
  }
  return data;
}
